import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/jsonMessages';
import history from '../../../core/history';
import { GoBackRightArrow } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cs from '../../../components/commonStyle.css';
import s from './SeeAll.css';

function SeeAll() {
  const handleClick = () => {
    history.push('/s');
  };

  return (
    <div className={cx(s.seeAllContainer)}>
      <Button className={cx(s.seeAllBtnnew, cs.fontWeightMedium,cs.displayFlex,cs.alignCenter,cs.gap4)} onClick={handleClick}>
        <span className={cs.vtrMiddle}>
          <FormattedMessage {...messages.viewAllText} />
        </span>
        <GoBackRightArrow className={'rtlRotate'}/>
      </Button>
    </div>
  );
}

export default injectIntl(withStyles(cs, s)(SeeAll));
